import(/* webpackMode: "eager" */ "/tmp/8de6359f438d20f/app/[locale]/error.tsx");
